import { useUser } from "@saleor/auth";
import { PermissionEnum } from "@saleor/graphql";
import { useMemo } from "react";

export const useDerivedPermissions = () => {
  const { zone } = useUser();
  const deliveryPermission = useMemo(() => {
    if (zone === "Domestic") {
      return [PermissionEnum.ALL_REPORT_ADMIN, PermissionEnum.LMS];
    }
    return [];
  }, [zone]);
  const pendingOrderPermission = useMemo(() => {
    if (zone === "Domestic") {
      return [PermissionEnum.ALL_REPORT_ADMIN];
    }
    return [];
  }, [zone]);
  const orderConfirmPermission = useMemo(() => {
    if (zone === "Domestic") {
      return [
        PermissionEnum.ALL_REPORT_ADMIN,
        PermissionEnum.VIEW_STOCK,
        PermissionEnum.VIEW_ORDER_CONFIRM_REPORT
      ];
    }
    return [];
  }, [zone]);

  const altMatPermission = useMemo(() => {
    if (zone === "Domestic") {
      return [PermissionEnum.MAINTAIN_ALT_MATERIAL];
    }
    return [];
  }, [zone]);

  const poUploadPermission = useMemo(() => {
    if (zone === "Domestic") {
      return [
        // PermissionEnum.ALL_UPLOAD_PO_CUSTOMER,
        PermissionEnum.ALL_UPLOAD_PO_ADMIN
      ];
    }
    return [];
  }, [zone]);

  const pendingOrderTrackingPermission = useMemo<PermissionEnum[]>(() => {
    if (zone === "Domestic") {
      return [PermissionEnum.VIEW_PENDING_ORDER_TRACKING];
    }
    return [];
  }, [zone]);

  const notRefCreateOrderTrackingPermission = useMemo<PermissionEnum[]>(() => {
    if (zone === "Domestic") {
      return [PermissionEnum.CREATE_ORDER_DOMESTIC_PACKAGING];
    }
    return [];
  }, [zone]);

  const listOfSaleOrderTrackingPermission = useMemo<PermissionEnum[]>(() => {
    if (zone === "Domestic") {
      return [PermissionEnum.VIEW_SALE_ORDER_TRACKING];
    }
    return [];
  }, [zone]);

  const excelUploadPermission = useMemo<PermissionEnum[]>(() => {
    if (zone === "Domestic") {
      return [PermissionEnum.MAINTAIN_EXCEL_UPLOAD];
    }
    return [];
  }, [zone]);

  return {
    deliveryPermission,
    pendingOrderPermission,
    orderConfirmPermission,
    altMatPermission,
    poUploadPermission,
    pendingOrderTrackingPermission,
    notRefCreateOrderTrackingPermission,
    listOfSaleOrderTrackingPermission,
    excelUploadPermission
  };
};
